import { Button, Space } from 'antd';
import moment from 'moment';
import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Link } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import NotifyAlert from '../../components/Notify/NotifyAlert';
import '../../components/Notify/NotifyAlert.css';
import PromotionApi from '../../functions/api/booking/PromotionApi';
import MyUtil from '../../functions/MyUtil';

export default class ButtonFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      edit: false,
      promotionInfo: '',
      view: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  async toggle() {
    if (!this.state.promotionInfo) {
      var detail = await PromotionApi.getDetailsPromotionByIdOrCode(
        this.props.row.promo_id
      );
      this.setState({ promotionInfo: detail });
    }
    this.setState({
      modal: !this.state.modal,
    });
  }
  handleDelete = async () => {
    var promotion = this.props.row;
    await this.submit(promotion);
  };

  handleEdit = () => {
    this.setState({
      edit: !this.state.edit,
    });
  };
  handleView = () => {
    this.setState({
      view: !this.state.view,
    });
  };

  submit = async (promotion) => {
    confirmAlert({
      title: 'Xóa khuyến mại',
      message: `Bạn có chắc chắn xóa khuyến mại ${promotion[
        'promo_code'
      ].toUpperCase()}`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            var result = await PromotionApi.deletePromotion(
              promotion['promo_id']
            )
              .then((result) =>
                NotifyAlert('Thành công', 'Xóa khuyến mại thành công!')
              )
              .catch((err) =>
                NotifyAlert('Lỗi', 'Đã xảy ra lỗi khi xoá khuyến mại!')
              );
            var list = this.props.list;
            list.forEach((item, index) => {
              if (item['promo_id'] === promotion['promo_id'])
                list.splice(index, 1);
            });

            this.props.onChangeList(list);
          },
        },
        {
          label: 'No',
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const promotion = this.state.promotionInfo[0];
    const canEdit = MyUtil.hasPermission('/promotion', 'update');
    const canDelete = MyUtil.hasPermission('/promotion', 'delete');

    return (
      <>
        <Space>
          {canEdit && (
            <Link to={'/promotion/edit-promotion/' + this.props.row.promo_id}>
              <Button size="small" onClick={() => this.handleEdit()}>
                <i className="fas fa-edit"></i>
              </Button>
            </Link>
          )}
          <Link to={'/promotion/view-promotion/' + this.props.row.promo_code}>
            <Button size="small" onClick={() => this.handleView()}>
              <i className="fas fa-list"></i>
            </Button>
          </Link>
          {canDelete && (
            <Button size="small" danger onClick={this.handleDelete}>
              <i className="fas fa-trash"></i>
            </Button>
          )}

          <Button size="small" onClick={() => this.toggle()}>
            <i className="fas fa-eye"></i>
          </Button>
        </Space>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className + ' detail-vehicle'}
        >
          <ModalHeader toggle={this.toggle}>Chi tiết khuyến mại</ModalHeader>
          {this.state.promotionInfo[0] && (
            <ModalBody style={{ fontSize: '16px' }}>
              <div className="title-detail-promotion">
                <b>Promotion ID:</b>
              </div>
              <span>{promotion['promo_id']}</span>
              <br />

              <div className="title-detail-promotion">
                <b>Promotion Code:</b>
              </div>
              <span>{promotion['promo_code'].toUpperCase()}</span>
              <br />

              <div className="title-detail-promotion">
                <b>Giá trị giảm:</b>
              </div>
              <span>
                {promotion['promo_val'] <= 100
                  ? `${promotion['promo_val']} %`
                  : `${MyUtil.currencyFormat(promotion['promo_val'])} vnđ`}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Áp dụng cho dòng xe:</b>
              </div>
              <span>
                {promotion['vhc_slug']
                  ? MyUtil.makeTitle(promotion['vhc_slug'])
                  : 'Tất cả các dòng xe'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Áp dụng cho đối tác:</b>
              </div>
              <span>
                {promotion['part_name']
                  ? promotion['part_name']
                  : 'Tất cả đối tác'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Áp dụng cho xe của đối tác:</b>
              </div>
              <span>
                {promotion['vhc_part_name']
                  ? promotion['vhc_part_name']
                  : 'Tất cả xe của đối tác'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Thời gian áp dụng khuyến mãi:</b>
              </div>
              <span>{`${moment(promotion['promo_active']).format(
                'DD/MM/YYYY'
              )} - ${moment(promotion['promo_expire']).format(
                'DD/MM/YYYY'
              )}`}</span>
              <br />

              <div className="title-detail-promotion">
                <b>Trạng thái kích hoạt:</b>
              </div>
              <span>
                {promotion['is_active'] ? 'Đang kích hoạt' : 'Không kích hoạt'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Hiển thị trên Website:</b>
              </div>
              <span>
                {promotion['is_show'] ? 'Có hiển thị' : 'Không hiển thị'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Ngày khởi tạo:</b>
              </div>
              <span>{`${moment(promotion['promo_crta']).format(
                'DD/MM/YYYY'
              )}`}</span>
              <br />

              <div className="title-detail-promotion">
                <b>Ngày cập nhật (cuối cùng):</b>
              </div>
              <span>{`${moment(promotion['promo_upda']).format(
                'DD/MM/YYYY'
              )}`}</span>
              <br />
            </ModalBody>
          )}
        </Modal>
      </>
    );
  }
}
